module.exports = __webpack_public_path__ + "static/media/ets-logo2.761c0793.png";